<div style="padding-top: 56px;">
    <div class="container-fluid" id="centerform">
        <div class="row w-100">
            <div class="col-md-4 offset-4">
                <div class="card">
                    <div class="card-header">
                        <h6>Set Password
                            <small class="float-right">
                                <a (click)="redirectLogin()"><i class="fas fa-arrow-left"></i></a>
                            </small>
                        </h6>

                    </div>
                    <div class="card-body">
                        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div class="form-group">
                                <label> New Password<span class="text-center text-danger">*</span></label>
                                <input [type]="show_button1 ? 'text' : 'password'" class="form-control" placeholder="New password" formControlName="newPassword" maxlength="20" [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }">
                                <i class="eye-icon-pos" [class]="show_eye1 ? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="showPassword('new')"> </i>
                                <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback d-block">
                                    <div *ngIf="f.newPassword.errors.required">New Password is required</div>
                                    <div *ngIf="f.newPassword.errors.passwordValid && !f.newPassword.errors.required">New Password is invalid format</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label> Confirm Password<span class="text-center text-danger">*</span></label>
                                <input [type]="show_button2 ? 'text' : 'password'" class="form-control" placeholder="Confirm password" formControlName="ConfirmPassword" maxlength="20" [ngClass]="{ 'is-invalid': submitted && f.ConfirmPassword.errors }">
                                <i class="eye-icon-pos" [class]="show_eye2 ? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="showPassword('confirm')"> </i>
                                <div *ngIf="submitted && f.ConfirmPassword.errors" class="invalid-feedback d-block">
                                    <div *ngIf="f.ConfirmPassword.errors.required">Confirm Password is required</div>
                                    <div *ngIf="f.ConfirmPassword.errors.passwordValid && !f.ConfirmPassword.errors.required">Confirm Password is invalid format</div>
                                </div>
                                <div class="mt-4">
                                    <button type="submit" class="btn btn-outline-main btn-sm mr-2">Update</button>
                                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearForm()">Clear</button>
                                </div>
                            </div>
                        </form>

                        <div class="card card-body mt-3 p-1 shadow-none border-0">
                            <span class="font-weight-bold">Note :</span>
                            <ul class="pl-3">
                                <li>Your password must be between 8 to 20 characters.</li>
                                <li>Your password must contain at least 1 capital letter (eg. A, B, etc).</li>
                                <li>Your password must contain at least 1 special character (eg. @, $, !, %, *, #, ?, &).</li>
                                <li>Do not refresh the page while generating password.</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>